var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighRiskCountries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1755 27.8969C30.2395 25.6989 33 21.3991 33 16.4545C33 9.27483 27.1797 3.45453 20 3.45453C12.8203 3.45453 7 9.27483 7 16.4545C7 21.5772 9.96298 26.0079 14.2686 28.1262",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5851 24.8928C13.8011 22.2627 12.9091 19.3586 12.9091 16.4545C12.9091 11.7273 15.2727 6.99998 20 3.45453",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4884 24.7834C26.2234 22.1823 27.0909 19.3184 27.0909 16.4545C27.0909 11.7273 24.7273 6.99998 20 3.45453",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.4545H33",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.2273L20 3.45457",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36365 9.36365C12.9091 11.7273 16.4546 12.9091 20 12.9091C23.5455 12.9091 27.0909 11.7273 30.6364 9.36365",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36365 23.5455C12.3991 21.5218 15.4346 20.3645 18.47 20.0734",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7727 20.0984C24.7272 20.4267 27.6818 21.5757 30.6363 23.5454",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1401 19.0845C19.5276 18.4319 20.4723 18.4319 20.8598 19.0845L30.3304 35.0349C30.7262 35.7015 30.2458 36.5454 29.4705 36.5454H10.5294C9.7542 36.5454 9.2738 35.7015 9.66959 35.0349L19.1401 19.0845Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5455V30.6364",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 34.5364C20.5221 34.5364 20.9454 34.1131 20.9454 33.5909C20.9454 33.0687 20.5221 32.6454 19.9999 32.6454C19.4777 32.6454 19.0544 33.0687 19.0544 33.5909C19.0544 34.1131 19.4777 34.5364 19.9999 34.5364Z",
    fill: "#F4F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskCountries);
export default __webpack_public_path__ + "static/media/HighRiskCountries.947fde1b917e14285cc97d4c284fb989.svg";
export { ForwardRef as ReactComponent };